/*
* DatagridReference component specific for Adalia M&E.
*
* Loads datagrid rows as options (As selection options, each project should contain a list of own datagrid rows only)
*
* Project can be passed as a prop, but if not, this component expects the document to contain an element with an id report-container
* and that element have a data-attribute called project-id.
* 
*/
import React from 'react';
import update from 'immutability-helper';

import { fetchJson } from '../../../../helpers/fetch.js';

import {
  Mode,
  DataType,
} from '../../common.jsx';
import Helpers from '../helpers.jsx';
import Setting from '../setting.jsx';

import DropdownSelectionWithAsyncOptions from '../dropdown_selection_with_async_options.jsx';
import GridLayout from '../grid_layout.jsx';

import { datagrid_column_rows_for_select_path } from '~/routes';

export default class AdaliaMEDatagridReference extends GridLayout {

  static get CATEGORY() {
    return 'question';
  }

  static get TYPE() {
    return 'adalia_me_datagrid_reference';
  }

  static icon() {
    return <i className='fa fa-table-list'></i>;
  }

  constructor(props) {
    super(props);
    this.addRow = this.addRow.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.addColumn = this.addColumn.bind(this);
    this.deleteColumn = this.deleteColumn.bind(this);
    this.reorderOption = this.reorderOption.bind(this);
    this.state = {}
  }

  static defaultContent(language) {
    let fieldName = 'field_' + Helpers.randomString();

    return Object.assign(super.defaultContent(language), {
      level: 'project',
      name: fieldName,
      rows: [
        [
          {
            span: 1,
            component: Object.assign(AdaliaMEDatagridReferenceSelector.defaultContent(language), {
              name: fieldName + '_dropdown',
              deletable: true,
              sortable: true
            })
          }
        ]
      ]
    });
  }

  componentDidMount() {
    super.componentDidMount();

    if (typeof this.props.updateSettingsCallback == 'function') {
      let datagridReferenceSelector = this.props.content.rows[0][0].component;
      let {reportKey, translations} = this.props.content;

      this.props.updateSettingsCallback(
        this.props.content.id,
        update(this.props.content, {$merge: Object.assign(datagridReferenceSelector, {reportKey: reportKey, translations: translations})})
      );
    }
  }

  renderSettings() {
    return <></>
  }
}


export class AdaliaMEDatagridReferenceSelector extends DropdownSelectionWithAsyncOptions {

  static get TYPE() {
    return 'adalia_me_datagrid_reference_selector';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'component_title_adalia_me_datagrid_reference',
      description: 'field_default_description',
      help: null,
    };
  }

  static get SETTINGS_DUMMY_DATA() {
    return [
      { value: 1, label: 'Datagrid row 1'},
      { value: 2, label: 'Datagrid row 2'},
      { value: 3, label: 'Datagrid row 3'}
    ];
  }

  static dropAllowed(dropArea, droppedContent, components, isNested) {
    return false
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      deletable: false,
      sortable: false,
      allowMultiple: false,
      reportKey: '',
      dataType: DataType.INTEGER,
      sourcesOfPrefill: ''
    });
  }

  static compatiblePrefillComponents() {
    return ['adalia_me_datagrid_reference_selector', 'adalia_me_datagrid_row_selector'];
  }

  static compatiblePrefillDataTypes() {
    return [DataType.INTEGER];
  }

  componentDidMount() {
    super.componentDidMount();

    let project_id = this.props.project?.id || jQuery('#report-container').data('project-id');
    let datagrid_col_id = this.props.content.colId;

    if (!project_id || [Mode.EDIT, Mode.SETTINGS].includes(this.props.mode)) {
      this.setState({
        options: this.constructor.SETTINGS_DUMMY_DATA,
        loading: false
      });

    } else {
      fetchOptionsForSelect(
        datagrid_col_id,
        project_id,
        this.context.programmeFormId,
        this.getAnswer(),
        this.props.handleDisbursement,
        (res) => {
          if (res) {
            this.setState({
              options: res,
              loading: false
            })
          }
        });
    }
  }

  onChange = (value) => {
    this.updateAnswer(value);
  };

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate();
  }

  renderSettings() {
    return <div>
      <Setting.TextField name='label' label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name='label_hidden' className='label-hidden-check' label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
      <Setting.TextField
        name="reportKey"
        label={I18n.t('field_report_key', {scope: 'fe'})}
        value={this.props.content.reportKey}
        description={I18n.t('field_report_key_description', {scope: 'fe'})}
        {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
      />
      {this.renderSourcesOfPrefillSettings()}
    </div>
  }

  beforeUpdateSettings(content) {
    super.beforeUpdateSettings(content);
  }
}

const fetchOptionsForSelect = (datagrid_col_id, project_id, programme_form_id, selected, handlingEnabled, cb) => {
  fetchJson(datagrid_column_rows_for_select_path({ datagrid_col_id: datagrid_col_id, project_id: project_id, programme_form_id: programme_form_id, _options: true })).then(
    (res) => {
      cb(res.map(p => ({ ...p })));
    }
  )
};
